import type { Account } from '@skoka/core';

/**
 * Какой счёт стоит за подписью банка — догадка до первого выбора человека.
 *
 * «Black» — это «Т-black»: подпись входит в название. «Credit card» —
 * единственная кредитка, если она одна. Иначе не угадываем: чужой счёт в
 * операции хуже пустого поля, которое человек заметит.
 */
export function guessAccount(label: string, accounts: readonly Account[]): string | undefined {
  const l = label.trim().toLowerCase();
  if (!l) return undefined;
  const tail = l.match(/(?:[*•хx]{2,}|(?:карта|card)\s*)\s*(\d{4})\b/i)?.[1];
  if (tail) {
    const cards = accounts.filter((a) => a.kind !== 'cash' && new RegExp(`(?:^|\\D)${tail}(?:$|\\D)`).test(a.name));
    return cards.length === 1 ? cards[0]!.id : undefined;
  }
  const byName = accounts.filter((a) => {
    const n = a.name.toLowerCase();
    return n.includes(l) || l.includes(n);
  });
  if (byName.length > 0) return byName.length === 1 ? byName[0]!.id : undefined;
  if (/credit|кредит/.test(l)) {
    const cards = accounts.filter((a) => a.kind === 'credit_card');
    if (cards.length === 1) return cards[0]!.id;
  }
  return undefined;
}

/** Однозначно распознанный счёт, исходный выбор, затем обычный счёт по умолчанию. */
export function importAccountId(accounts: readonly Account[], initialAccountId?: string, label?: string | null): string {
  const active = accounts.filter((a) => !a.archived);
  return (label ? guessAccount(label, active) : undefined)
    ?? active.find((a) => a.id === initialAccountId)?.id
    ?? active.find((a) => a.isLiquid)?.id ?? active[0]?.id ?? '';
}

/** В выписке незнакомая подпись без исходной операции требует выбора человека. */
export function statementAccountId(accounts: readonly Account[], label: string, initialAccountId?: string, rememberedId?: string): string {
  const active = accounts.filter((a) => !a.archived);
  if (!label.trim()) return importAccountId(active, initialAccountId);
  return active.find((a) => a.id === rememberedId)?.id
    ?? guessAccount(label, active)
    ?? active.find((a) => a.id === initialAccountId)?.id ?? '';
}
